// src/components/Analytics.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Add this interface declaration
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

type AnalyticsParamValue = string | number | boolean;

export const trackEvent = (
  eventName: string,
  params?: Record<string, AnalyticsParamValue>
) => {
  if (typeof window.gtag === "function") {
    window.gtag("event", eventName, params || {});
  }
};

export const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    trackEvent("page_view", {
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null;
};